import { CupomModel, CupomLoteModel } from '@/models/CupomModel'

// Mesma regra do backend (EventoService.calcularDescontoCupom):
// - cupom sem lotes: vale para todas as áreas que aceitam cupom
// - cupom com lotes: só nos lotes listados; com quantidade_maxima, o desconto vai até
//   essa quantidade de ingressos do lote e o restante fica com valor cheio.
// - quantidade_exigida (no lote ou no cupom geral): só tem desconto com exatamente essa quantidade;
//   no cupom geral a conta é pelo total de ingressos do pedido nas áreas que aceitam cupom.

type CupomRegra = Pick<CupomModel, 'desconto' | 'lotes' | 'quantidade_exigida'>

export function cupomValeParaLote(cupom: CupomRegra | null | undefined, areaAceitaCupom: boolean | undefined, loteId: number): boolean {
    if (!cupom || !areaAceitaCupom) return false
    if (!cupom.lotes?.length) return true

    return cupom.lotes.some((o) => o.lote_id == loteId)
}

export function calcularDescontoCupom(
    cupom: CupomRegra | null | undefined,
    areaAceitaCupom: boolean | undefined,
    loteId: number,
    valorUnitario: number,
    quantidade: number,
    quantidadeTotalPedido = quantidade
): number {
    if (!cupom || !cupomValeParaLote(cupom, areaAceitaCupom, loteId) || quantidade <= 0) return 0

    let quantidadeComDesconto = quantidade
    const regraLote = cupom.lotes?.find((o) => o.lote_id == loteId)

    if (regraLote?.quantidade_exigida && quantidade != regraLote.quantidade_exigida) return 0

    if (!cupom.lotes?.length && cupom.quantidade_exigida && quantidadeTotalPedido != cupom.quantidade_exigida) return 0

    if (regraLote?.quantidade_maxima && regraLote.quantidade_maxima > 0) {
        quantidadeComDesconto = Math.min(quantidade, regraLote.quantidade_maxima)
    }

    return Math.floor(valorUnitario * (cupom.desconto / 100)) * quantidadeComDesconto
}

export function descricaoLotesCupom(cupom: Pick<CupomModel, 'lotes' | 'quantidade_exigida'>): string {
    if (!cupom.lotes?.length) {
        return cupom.quantidade_exigida ? `pedidos com exatamente ${cupom.quantidade_exigida} ingresso(s)` : ''
    }

    return cupom.lotes
        .map((o) => {
            const regras = [
                o.quantidade_exigida ? `comprando exatamente ${o.quantidade_exigida}` : '',
                o.quantidade_maxima ? `desconto em até ${o.quantidade_maxima} ingresso(s)` : ''
            ].filter((r) => r)

            return `${o.nome ?? 'Lote ' + o.lote_id}${regras.length ? ` (${regras.join(', ')})` : ''}`
        })
        .join(', ')
}

// Texto da regra de um lote, para exibir ao cliente. Ex.: "comprando exatamente 2 ingressos"
export function descricaoRegraLote(regra: Pick<CupomLoteModel, 'quantidade_exigida' | 'quantidade_maxima'>): string {
    const regras = [
        regra.quantidade_exigida ? `comprando exatamente ${regra.quantidade_exigida} ingresso(s)` : '',
        regra.quantidade_maxima ? `desconto em até ${regra.quantidade_maxima} ingresso(s) por pedido` : ''
    ].filter((r) => r)

    return regras.length ? regras.join(', ') : 'em qualquer quantidade'
}
